import { Table } from "components/Datatable";
import { Message, Spinner, Stack, Text } from "@adfenix/alexandria";
import { StripeService } from "@adfenix/types";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import {
  getStripeHqTransactionGroups,
  getStripeOfficeTransactionGroups
} from "api/services";

export interface GroupedProps {
  mode: "office" | "hq";
  subjectId: string;
}

export const GroupedTransactionsTable = ({ subjectId, mode }: GroupedProps) => {
  const { t } = useTranslation();
  const { data, isLoading } = useQuery(["grouped-stripe-transactions"], () =>
    mode === "hq"
      ? getStripeHqTransactionGroups(subjectId)
      : getStripeOfficeTransactionGroups(subjectId)
  );

  if (isLoading) {
    return (
      <Stack spacing="m">
        <Message>Preparing monthly statements. This might take a while</Message>
        <Spinner />
      </Stack>
    );
  }

  return (
    <Table
      pagination={data && data?.length > 10}
      keyField="id"
      defaultSortField="created"
      defaultSortAsc={false}
      columns={[
        {
          name: t("billing_charge_history_date_column"),
          selector: (row: StripeService.GroupedInvoices) => row.groupName,
          cell: (row: StripeService.GroupedInvoices) => (
            <Text data-testid="transaction-month">{row.groupName}</Text>
          )
        },

        {
          name: "",
          right: true,
          button: true,
          selector: (row: StripeService.GroupedInvoices) => row.fileUrl,
          cell: (row: StripeService.GroupedInvoices) => (
            <Text data-testid="transaction-link">
              {" "}
              <a
                href={row.fileUrl}
                target="_blank"
                rel="noreferrer"
                data-loglabel="view-monthly-report-link"
              >
                {t("billing_charge_history_view_receipt_label")}
              </a>
            </Text>
          )
        }
      ]}
      data={data || []}
    />
  );
};
